import React from 'react';

interface StatCardProps {
  value: string;
  label: string;
  variant?: 'light' | 'dark';
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  variant = 'light',
  className = '',
}) => {
  // Updated styles for a lighter, modern look
  const bgColor = variant === 'dark' ? 'bg-blue-800' : 'bg-white';
  const borderColor = variant === 'dark' ? 'border-blue-600' : 'border-blue-100';
  const valueColor = variant === 'dark' ? 'text-white' : 'text-blue-600';
  const labelColor = variant === 'dark' ? 'text-blue-100' : 'text-gray-500';
  const valueFont = 'font-mono font-medium tracking-wide';
  const valueShadow = variant === 'dark' ? '' : 'drop-shadow-sm';

  return (
    <div className={`stat_card p-6 sm:p-8 rounded-xl border ${borderColor} ${bgColor} shadow-md hover:shadow-lg transition-all duration-300 ${className}`}>
      <div className={`stat_value text-4xl sm:text-5xl ${valueFont} ${valueColor} ${valueShadow} mb-2`} style={{letterSpacing: '0.01em'}}>
        {value}
      </div>
      <div className={`stat_label ${labelColor}`}>
        {label}
      </div>
    </div>
  );
};
